import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//定义路由路径
let routes = require('./routesMaker').default

const router = new Router({
  mode: 'history',
  base: __dirname,
  linkActiveClass: 'active',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
export default router
